import { pick } from 'ramda'
import { apiRequest } from 'utils/request'
import createUri from 'utils/uriCreators'

export const getReferenceParameter = ({
  referenceParameterNumber,
  releaseNumber,
}) =>
  apiRequest({
    uri: createUri.referenceParameter({
      referenceParameterNumber,
      releaseNumber,
    }),
  })

export const getReferenceParameterNotes = ({
  referenceParameterNumber,
  releaseNumber,
}) =>
  apiRequest({
    method: 'GET',
    uri: `/reference-parameters/${referenceParameterNumber}/${releaseNumber}/revisions`,
  })

export const getReferenceParameterCircuits = ({
  referenceParameterNumber,
  releaseNumber,
}) =>
  apiRequest({
    method: 'GET',
    uri: `/reference-parameters/${referenceParameterNumber}/${releaseNumber}/circuits`,
  })

export const getReferenceParametersCircuits = ({ rps }) => {
  const requestString = rps
    .map((rp) => rp.uri)
    .reduce((previousValue, currentValue, index) => {
      // encode uri component so that + becomes %2B
      const rpValue = encodeURIComponent(
        currentValue.replace('/reference-parameters/', '')
      )
      const delimiter = index === 0 ? '' : '&'
      return `${previousValue}${delimiter}uris=${rpValue}`
    }, '')
  return apiRequest({
    method: 'GET',
    uri: `reference-parameters/circuits?${requestString}`,
  })
}

export const saveReferenceParameter = ({ referenceParameter }) =>
  apiRequest({
    method: 'POST',
    uri: '/reference-parameters/update',
    body: pick(
      [
        'uri',
        'refParameterNumber',
        'serviceDescription',
        'itemDescription',
        'masterNumber',
        'notesDescription',
        'release',
        'status',
        'add',
        'remove',
        'duplicate',
      ],
      referenceParameter
    ),
  })

export const getRps = ({
  partUris = [],
  serialNumber,
  filterConflicts = false,
  search = '',
  startIndex = 1,
}) => {
  const requestString = partUris.reduce(
    (previousValue, currentValue, index) => {
      const rpValue = currentValue.replace('/reference-parameters/', '')
      const delimiter = index === 0 ? '' : '&'
      return `${previousValue}${delimiter}uris=${rpValue}`
    },
    ''
  )

  return apiRequest({
    method: 'GET',
    uri: `reference-parameters/vehicle-compatibility/${serialNumber}?${requestString}&count=${partUris.length}&index=${startIndex}&filterConflicts=${filterConflicts}&search=${search}`,
  })
}

export const duplicateReferenceParameter = ({
  originalReferenceParameter: { refParameterNumber, release },
}) =>
  apiRequest({
    method: 'POST',
    uri: `${createUri.referenceParameter({
      referenceParameterNumber: refParameterNumber,
      releaseNumber: release,
    })}/duplicate`,
  })

export const updateStatus = ({ uri, status }) =>
  apiRequest({
    method: 'POST',
    uri: `${uri}/status/update`,
    body: {
      status,
    },
  })

export const fetchSupportParamsForImport = ({ uri }) =>
  apiRequest({
    method: 'GET',
    uri,
  })

export const saveReferenceParamNotes = ({
  referenceParameterNumber,
  releaseNumber,
  notes,
}) =>
  apiRequest({
    method: 'POST',
    uri: `/reference-parameters/${referenceParameterNumber}/${releaseNumber}/revisions/add`,
    body: {
      eventNotes: notes,
      eventType: 'notes',
      objectType: 'referenceparameter',
      objectUri: createUri.referenceParameter({
        referenceParameterNumber,
        releaseNumber,
      }),
    },
  })

export const searchReferenceParameter = ({
  compatibleWith,
  count,
  startIndex,
  search,
  filterConflicts,
}) =>
  apiRequest({
    method: 'GET',
    uri: `reference-parameters/vehicle-compatibility/${compatibleWith}?count=${count}&startIndex=${startIndex}&filterConflicts=${filterConflicts}&description=${search}`,
  })
